import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Main from './container/main'
import MainRaincoatNeo from './container/mainRaincoatNeo';
import CircularProgress from '@material-ui/core/CircularProgress';
import history from './history';
import CacheBuster from './cacheBuster';
import ErrorMessage from './container/errorMessage';
import errorHandler from './errorHandler';
import packageJson from '../package.json';
global.appVersion = packageJson.version;

errorHandler.setInterceptors();

function App() {
  let hostName = 'hccinstantrewards'
  let userType = 'Paytm CC'

  // When need to run in local
  if (hostName === 'localhost') {
    // hostName = 'hccinstantrewards'
    hostName = 'hccinstantrewards'
  }

  if (hostName === 'hccinstantrewards') {
    userType = 'Paytm CC'
  }


  const path = window.location.pathname;
  const pathParams = path.split('/')

  const axios = require('axios').default;
  const HOST = process.env.REACT_APP_HOST;
  const API = process.env.REACT_APP_API;

  const [banner, setBanner] = useState('')
  const [validity, setValidity] = useState(true)
  const [isLoading, setIsLoading] = useState(true)
  const [errorThrow, setErrorThrow] = useState(false)
  const [correctCoupon, setCorrectCoupon] = useState('')
  const [newCoupon, setNewCoupon] = useState('')

  // version from response - first param, local version second param
  const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);

    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
      const a = Number(versionsA.shift());

      const b = Number(versionsB.shift());

      // eslint-disable-next-line no-continue
      if (a === b) continue;
      // eslint-disable-next-line no-restricted-globals
      return a > b || isNaN(b);
    }
    return false;
  };

  const vesionCompare = () => {
    fetch('/meta.json', { cache: 'no-cache' })
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;
        const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
        if (shouldForceRefresh) {
          if (caches) {
            // Service worker cache should be cleared with caches.delete()
            caches.keys().then(function (names) {
              for (let name of names) caches.delete(name);
            });
          }
          window.location.reload(true);
          localStorage.clear();
        }
      })
  }


  const get_bg_img = () => {

    axios
      .post(
        `${HOST}${API}get-background-image/`,
        {
          "user": userType,
          "host-name": hostName,
          "image-sub-type": pathParams[2],
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res) => {
        setIsLoading(false)
        setValidity(res.data.valid)
        setBanner(res.data.banner_url)
      })
      .catch((err) => {
        setIsLoading(true);
        setValidity(true);
        setErrorThrow(true);
        console.log(err);
      });
  }

  const get_correct_coupon_roofsealclassic = () => {
    axios
      .post(
        `${HOST}${API}find-correct-coupon/`,
        {
          "coupon": pathParams[2],
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res) => {
        setCorrectCoupon(res.data.hasOwnProperty('success'))
        setNewCoupon(res.data.new_coupon)
        setIsLoading(false)
        history.push(`/roofsealclassic/${res.data.new_coupon}`);
      })
      .catch((err) => {
        setCorrectCoupon(err.response.data.hasOwnProperty('success'))
        setNewCoupon(pathParams[2])
        console.log(err);
      });
  }

  useEffect(() => {
    get_bg_img();
    if (pathParams[1].toLowerCase() === "roofsealclassic") {
      get_correct_coupon_roofsealclassic();
    }
    const interval = setInterval(() => {
      vesionCompare()
    }, 7000);
    return () => clearInterval(interval);
  }
    , [])

  if (process.env.NODE_ENV !== "development") {
    console.log = () => { };
  }

  localStorage.removeItem("tran_status");
  localStorage.removeItem("error_throw");
  localStorage.removeItem("kyc_status");

  let isEndUserCategory =
    localStorage.getItem("division") == "BST"
      ?
      localStorage.getItem("isEndUserCategory") ?
        localStorage.getItem("isEndUserCategory") == 'PAINTING CONTRACTORS' ? 'pc' : 'ptr'
        : null : null;


  let urlSearchData = window.location.search;
  let dealer_sso = urlSearchData.split('?dealer=')[1];
  console.log("pathParams[1]", pathParams[1], dealer_sso);
  // console.log("pathParamspathParamspathParamspathParams", dealer_sso);
  
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (


          (pathParams[2].toLowerCase() == 'puenml' || isEndUserCategory == null ||
            pathParams[1].toLowerCase() == isEndUserCategory) ?
            (
              isLoading ? <CircularProgress /> : validity ?

                dealer_sso ?

                  (pathParams[1].toLowerCase() === 'ptr' || pathParams[1].toLowerCase() === 'pc') ?

                    pathParams[1].toLowerCase() === 'ptr' ?
                      <Router>
                        <img className='background-image' src={banner} alt="App Slides" />
                        <div className="App">
                          <Route path='/:projecttype/:subtype/:couponId' >
                            {pathParams[1].toLowerCase() === "raincoatneo" ?
                              <MainRaincoatNeo />
                              :
                              <Main dealer_sso={dealer_sso} isDashboard={false} />
                            }
                          </Route>
                        </div>
                      </Router>
                      :
                      <Router>
                        <img className='background-image' src={banner} alt="App Slides" />
                        <div className="App">
                          <ErrorMessage addClass="app5" />
                        </div>
                      </Router>
                    :
                    <Router>
                      <img className='background-image' src={banner} alt="App Slides" />
                      <div className="App">
                        <Route path='/'  >
                          {pathParams[1].toLowerCase() === "raincoatneo" ?
                            <MainRaincoatNeo />
                            :
                            <Main dealer_sso={dealer_sso} isDashboard={true} />
                          }
                        </Route>
                      </div>
                    </Router>
                  :
                  <Router>
                  <img className='background-image' src={banner} alt="App Slides" />
                  <div className="App">
                    <Route path='/:projecttype/:subtype/:couponId' >
                      {pathParams[1].toLowerCase() === "raincoatneo" ?
                        <MainRaincoatNeo />
                        :
                        <Main dealer_sso={dealer_sso} isDashboard={false} />
                      }
                    </Route>
                  </div>
                </Router>
                :
                null
               )
            :
            <Router>
              <img className='background-image' src={banner} alt="App Slides" />
              <div className="App">
                <ErrorMessage addClass="app2" />
              </div>
            </Router>


        )
      }}
    </CacheBuster>
  );
}

export default App;